import * as Sentry from '@sentry/react';

// capture errors only in production mode (yarn build)
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV,
  });
}
